import type { KeyboardLayout } from 'components/Keyboard/types';

import layoutCandidates from './defaultCandidates';

export default {
  layout: {
    default: [
      '年 月 日 時 分 {divider} 1 2 3',
      '× ÷ ＋ − ＝ {divider} 4 5 6',
      '々 ☆ ％ ¥ 〒 {divider} 7 8 9',
      '→ 〜 ・ … ○ {divider} 、 0 .',
      '{kaomoji} / （ ） {divider} ： {zenkaku}',
    ],
  },
  layoutCandidates,
} satisfies KeyboardLayout;
